module.exports = __webpack_public_path__ + "static/media/spy.4dba0d91.svg";